<template>
  <v-container id="extended-tables" fluid tag="section">
    <base-v-component heading="" link="componetns/simple-tables" />

    <base-material-card color="success" icon="mdi-clipboard-text" inline title="Grupos" class="px-5 py-3 mb-5">
      <v-row>
        <v-col cols="12" md="12" class="mt-10">
          <v-data-table :headers="headers" :items="grupos" sort-by="calories" class="elevation-1" :search="search"
            :loading="loadingTable" loading-text="Cargando... Por favor esperar">
            <template v-slot:item.consolidation="{ item }">
              <v-simple-checkbox v-model="item.consolidation" disabled></v-simple-checkbox>
            </template>
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Grupos de sensores</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                  hide-details></v-text-field>

                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" @click="editedIndex = -1">
                      Nuevo grupo
                    </v-btn>
                  </template>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-btn icon dark @click="close">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>{{ formTitle }} </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                      <v-form ref="form" v-model="validForm">
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field v-model="name" label="Grupo" required :rules="requiredRule"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-switch v-model="activo" inset color="red" label="Activo">
                              </v-switch>
                            </v-col>

                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" @click="close"> Cerrar </v-btn>
                      <v-btn color="primary" @click="guardar()"> GUardar </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5">Esta seguro de eliminar datos?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" large @click="editarMAscota(item)">
                    <v-icon dense color="secondary">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar datos</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" large @click="deleteItem(item)">
                    <v-icon dense color="primary">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>

            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize"> Recargar </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

    </base-material-card>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "DashboardExtendedTables",

  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "Nombre", value: "name" },
      { text: "Consolidación", value: "consolidation" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    grupos: [],
    editedIndex: -1,
    name: "",
    activo: true,
    id: "",
    search: "",
    loadingTable: true,
    snackbar: false,
    text: "",
    timeout: 6000,
    validForm: false,
    requiredRule: [(v) => !!v || 'Este campo es obligatorio'],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo grupo" : "Editar grupo";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 6000);

      this.loader = null;
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.listar();
    },

    listar() {
      let me = this;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Groups", configuracion)
        .then(function (response) {
          me.grupos = response.data;
          //change to string bool value
          me.loadingTable = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        }
        );
    },
    guardar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          //edit
          console.log("Actualizar " + me.unico);
          axios
            .post(
              "/api/Groups/UpdateGroup",
              {
                id: me.id,
                name: me.name,
                consolidation: me.activo,
              },
              configuracion
            )
            .then(function (response) {
              me.listar();
              console.log(response);
            })
            .catch((err) => {
              if (err.response.status == 401) {
                this.$store.dispatch("salir");
              }
            });
        } else {
          console.log("crear medicamento");
          axios
            .post(
              "/api/Groups/InsertGroup",
              {
                name: me.name,
                consolidation: me.activo,

              },
              configuracion
            )
            .then(function (response) {
              me.listar();
              console.log(response);
            })
            .catch((err) => {
              if (err.response.status == 400) {
                me.snackbar = true;
                me.text = err.response.data.errors;
              }
              if (err.response.status == 401) {
                this.$store.dispatch("salir");
              }
            });
        }
        this.close();
      }
     
    },
    editItem(item) {
      //this.editedIndex = this.desserts.indexOf(item);
      //this.editedItem = Object.assign({}, item);
      console.log(item);
      this.dialog = true;
    },

    deleteItem(item) {
      let me = this;
      me.id = item.id;
      console.log(item);
      me.dialogDelete = true;
    },

    deleteItemConfirm() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Groups/Delete/" + me.id, configuracion)
        .then(function (response) {
          me.dialogDelete = false;
          if (response.data[0]["error"]) {
            me.snackbar = true;
            me.text = response.data[0]["messagge"];
          }
          me.listar();
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        }
        );
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>